export default __webpack_public_path__ + "static/media/gallery_17.e889f851.jpg";